module.exports = __webpack_public_path__ + "img/2ezBanner2.90b563de.jpg";